/* template */
<template minapp="mpx" xlang="wxml"><mpx-view @tap="clickBtn" class="coupon-button-container"><div :style="[(btnStyle)] | transRpxStyle" class="coupon-button">{{ BtnText }}</div></mpx-view></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m4fc1e5ee"}'>
  .coupon-button-container
    position relative
    .coupon-button
      width 160px
      height 45px
      border-radius 25px
      font-size 18px
      font-weight 800
      line-height 45px
      text-align center
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m4fc1e5ee"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./coupon-btn.mpx.js?isComponent&outputPath=components%2Fcoupon-btn4fc1e5ee%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./coupon-btn.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Fcoupon-btn4fc1e5ee%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m4fc1e5ee"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/coupon-btn4fc1e5ee/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'mpx-view':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
